import { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Badge } from "@/components/ui/badge";
import { Check, CaretDown, X } from "@phosphor-icons/react";
import { Input } from "@/components/ui/input";

export const MultiSelect = ({ options = [], value = [], onChange, placeholder = "Select…" }) => {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const filtered = options.filter((o) => o.label.toLowerCase().includes(q.toLowerCase()));
  const toggle = (v) => {
    if (value.includes(v)) onChange(value.filter((x) => x !== v));
    else onChange([...value, v]);
  };
  const selected = options.filter((o) => value.includes(o.value));

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button data-testid="multi-select-trigger" type="button" className="w-full min-h-[40px] flex items-center justify-between gap-2 border border-slate-300 rounded-md bg-white px-3 py-2 text-sm hover:border-slate-400 focus:outline-none focus:ring-2 focus:ring-[#fd7e14]">
          <div className="flex flex-wrap gap-1 flex-1 text-left">
            {selected.length === 0 && <span className="text-slate-400">{placeholder}</span>}
            {selected.map((s) => (
              <Badge key={s.value} variant="secondary" className="gap-1">
                {s.label}
                <span role="button" onClick={(e) => { e.stopPropagation(); toggle(s.value); }} className="hover:text-red-600">
                  <X size={10} />
                </span>
              </Badge>
            ))}
          </div>
          <CaretDown size={14} className="text-slate-400" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-[--radix-popover-trigger-width] p-0" align="start">
        <div className="p-2 border-b">
          <Input data-testid="multi-select-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search…" className="h-8 text-sm" />
        </div>
        <div className="max-h-64 overflow-y-auto py-1">
          {filtered.length === 0 && <div className="px-3 py-4 text-xs text-slate-400 text-center">No results</div>}
          {filtered.map((o) => {
            const isSel = value.includes(o.value);
            return (
              <button
                type="button"
                key={o.value}
                onClick={() => toggle(o.value)}
                className={`w-full flex items-center justify-between px-3 py-1.5 text-sm hover:bg-slate-100 ${isSel ? "bg-slate-50" : ""}`}
              >
                <span>{o.label}</span>
                {isSel && <Check size={14} className="text-[#fd7e14]" />}
              </button>
            );
          })}
        </div>
      </PopoverContent>
    </Popover>
  );
};
